import { get } from 'svelte/store';

import {
    BALL_DEFAULT_UI_TYPE,
    BALL_PAGE_TYPE,
    BALL_PUB_PAGE,
    type BallPageType
} from '../constants/pageType';
import { ballPageType } from '../store/index';

export const initBallPageType = (type: BallPageType) => {
    ballPageType.set(type);

    if (typeof document !== 'undefined') {
        document.documentElement.dataset.ballPage = type;
        document.body.classList.remove(
            'ball-page-regular',
            'ball-page-end',
            'ball-page-msi'
        );
        document.body.classList.add(`ball-page-${type}`);
    }
};

export const getBallPageType = (): BallPageType => get(ballPageType);

export const isRegularPage = () => getBallPageType() === BALL_PAGE_TYPE.REGULAR;

export const isEndPage = () => getBallPageType() === BALL_PAGE_TYPE.END;

export const isMsiPage = () => getBallPageType() === BALL_PAGE_TYPE.MSI;

export const resolvePubPage = () => BALL_PUB_PAGE[getBallPageType()];

export const resolveDefaultUiType = () => BALL_DEFAULT_UI_TYPE[getBallPageType()];

/** msi：cardLogin/fifa + 领奖 */
export const usesFifaCardLogin = () => isMsiPage();

/** regular：legacy CreditCardLoginFlow */
export const usesLegacyLoginFlow = () => isRegularPage();

/** end：loginType E 布局，无独立 /login 路由 */
export const usesEndLoginLayout = () => isEndPage();
